import { Component, ElementRef, Injector, OnDestroy, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, TemplatePortal } from '@angular/cdk/portal';
import { FocusTrap, FocusTrapFactory } from '@angular/cdk/a11y';
import { Observable, Subject } from 'rxjs';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { AddCategoryDialogComponent } from './add-category-dialog/add-category-dialog.component';
import { StorageserviceService } from '../../core/services/storageservice.service';
import { AddDocumentDialogComponent} from './add-document-dialog/add-document-dialog.component';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { SharedocumentdialogComponent } from './sharedocumentdialog/sharedocumentdialog.component';
import { AuthService } from 'src/app/core/services/auth.service';
import { DataService } from 'src/app/core/services/data.service';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { id } from 'date-fns/locale';
import { MatTableDataSource } from '@angular/material/table';
import { AfterViewInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DoctypePipe } from 'src/app/core/services/doctype.pipe';


interface IconMapping {
  key: string;
  imagePath: string;
}

interface Document {
  id: string;
  name: any;
  category: string[];
  doctype?: string; // For identity documents
  documentId?: string; // For identity documents
  docid?: string; // Added to fix compile error
  uploadDate: Date;
  expirationDate?: Date;
  description: string;
  fileSize: string;
  tags: string[];
  user_tags?: string[];
  thumbnail?: string;
  fileData?: File;
  fileDataUrl?: string;
  previewUrl?: SafeUrl;
  mimeType?: string;
  uploadProgress?: number;
  country?: string;
}

interface DocumentCategory {
  id: string;
  title: string;
  count: number;
  icon: string;
  isActive: boolean;
  documentTypes?: any[]; // For identity category
}

@Component({
    selector: 'app-documents',
    templateUrl: './documents.component.html',
    styleUrls: ['./documents.component.css'],
    standalone: false
})
export class DocumentsComponent implements OnInit, OnDestroy {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('cardContainer', { read: ElementRef }) cardContainer!: ElementRef;
  @ViewChild('previewTpl', { static: true }) previewTpl!: TemplateRef<unknown>;

  paginatedDocuments: any[] = [];
  viewMode: 'grid' | 'list' = 'list';
  sortBy: string = 'name';
  searchQuery: string = '';
  searchText:string = '';
  displayedColumns: any[] = [
    'name',
    'description',
    'uploadedOn',
    'expiringOn',
    'tags',
    'actions'
  ];
  // sortOptions = [
  //   { label: 'Sort by Name', icon: 'sort_by_alpha', action: () => this.onSort('name') },
  //   { label: 'Sort by Date', icon: 'date_range', action: () => this.onSort('date') },
  // ];

  sortOptions = [
    { label: 'A to Z', icon: 'bi bi-sort-alpha-down', action: () => this.onSort('name','asc') },
    { label: 'Z to A', icon: 'bi bi-sort-alpha-down-alt', action: () => this.onSort('name','desc') },
    { label: 'Old to New', icon: 'bi bi-arrow-up', action: () => this.onSort('date','asc') },
    { label: 'New to Old', icon: 'bi bi-arrow-down', action: () => this.onSort('date', 'desc') },
  ];

  dropdownOptions = [
    { label: 'Document', icon: 'description', action: this.onAddDocument.bind(this) },
    { label: 'Folder', icon: 'category', action: this.onAddCategory.bind(this) },
  ];
  allowedFileTypes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet','application/rtf','text/csv','text/rtf','rtf'];
  docapi = environment.doc2pdf;

  documents: Document[] = [];
  allDocuments: Document[] = [];
  pageSize = 10;
  currentPage = 0;
  totalDocuments = 0;

  documentCategories: DocumentCategory[] = [
    {
      id: 'identity',
      title: 'Identity',
      count: 0,
      icon: 'badge',
      isActive: true,
      documentTypes: [{ value: 'aadhar', title: 'Aadhar' }, { value: 'passport', title: 'Passport' }, { value: 'driver_license', title: 'Driver License' }, { value: 'voter_id', title: 'Voter Id' }
      ]
    }
  ];
  citizenships: any[] = [];
  selectedCitizenship: any;

  // Add new properties for file preview
  previewDocument: Document | null = null;
  // The preview is shown through the CDK overlay container (a body-level layer shared with MatDialog), not inline in
  // the page. Inline, its position:fixed layer was trapped inside the app shell's page-content stacking context and
  // rendered underneath the sidebar. Every existing `isPreviewOpen = true/false` call site keeps working unchanged.
  private previewOverlayRef: OverlayRef | null = null;
  private _isPreviewOpen = false;
  get isPreviewOpen(): boolean {
    return this._isPreviewOpen;
  }
  set isPreviewOpen(open: boolean) {
    this._isPreviewOpen = open;
    if (open) {
      this.attachPreviewOverlay();
    } else {
      this.detachPreviewOverlay();
    }
  }
  index_country = "citizen_primary";
  tagSelected='identity';
  selectedcountry:any;
  // Health Dashboard deep link (router state). Only set when the dashboard navigates here; a normal visit leaves both null.
  private dashboardLink: { category: string; docId?: string; add?: boolean } | null = null;
  private dashboardAction: { docId?: string; add?: boolean } | null = null;
  isPreviewLoading = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  sortDirection: { [key: string]: 'asc' | 'desc' } = {};
  
 iconMappings: IconMapping[] = [
  // Default category icons (converted to image paths)
  { key: 'card_membership', imagePath: 'assets/identity-card.png' }, // or use existing identity icon
  { key: 'insert_drive_file', imagePath: 'assets/personal-card.png' },
  { key: 'local_hospital', imagePath: 'assets/health-card.png' },
  { key: 'gavel', imagePath: 'assets/gavel-card.png' },
  { key: 'person', imagePath: 'assets/streamline_business-user-curriculum.png' },
  { key: 'account_balance', imagePath: 'assets/finance_card.png' },
  { key: 'legal-card', imagePath: 'assets/images/document/legal-doc.svg' },
  { key: 'personal-card', imagePath: 'assets/images/document/personal-doc.svg' },
  
  // Custom category icons (your existing mappings)
  { key: 'file_folder', imagePath: 'assets/file_folder.png' },
  { key: 'building-office', imagePath: 'assets/building-office.png' },
  { key: 'carbon_finance', imagePath: 'assets/carbon_finance.png' },
  { key: 'fluent-mdl2_education', imagePath: 'assets/fluent-mdl2_education.png' },
  { key: 'healthicons_ui-folder-family-outline', imagePath: 'assets/healthicons_ui-folder-family-outline.png' },
  { key: 'hugeicons_invoice-02', imagePath: 'assets/hugeicons_invoice-02.png' },
  { key: 'Folder-lock', imagePath: 'assets/Folder-lock.png' },
  { key: 'Book-mark', imagePath: 'assets/Book-mark.png' },
  { key: 'Book-open', imagePath: 'assets/Book-open.png' },
  { key: 'capsule', imagePath: 'assets/capsule.png' },
  { key: 'target', imagePath: 'assets/target.png' },
  { key: 'download_3', imagePath: 'assets/download_3.png' },
  { key: 'ep_goods', imagePath: 'assets/ep_goods.png' },
  { key: 'flight_takeoff', imagePath: 'assets/flight_takeoff.png' },
  { key: 'fluent_mail-24-regular', imagePath: 'assets/fluent_mail-24-regular.png' },
  { key: 'hugeicons_analytics-up', imagePath: 'assets/hugeicons_analytics-up.png' },
  { key: 'leaf', imagePath: 'assets/leaf.png' },
  { key: 'lets-icons_shop-light', imagePath: 'assets/lets-icons_shop-light.png' },
  { key: 'location', imagePath: 'assets/location.png' },
  { key: 'lucide_briefcase-business', imagePath: 'assets/lucide_briefcase-business.png' },
  { key: 'ph_certificate-light', imagePath: 'assets/ph_certificate-light.png' },
  { key: 'stack', imagePath: 'assets/Stack.png' },
  { key: 'streamline_business-user-curriculum', imagePath: 'assets/streamline_business-user-curriculum.png' },
  { key: 'streamline_group-meeting-call', imagePath: 'assets/streamline_group-meeting-call.png' },
];
// preview.component.ts
readonly IMAGE_MIME_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/webp',
  'image/bmp',
  'image/tiff',
  'image/x-icon'
]);

isImage(mimeType: any): any {
  return this.IMAGE_MIME_TYPES.has(mimeType);
}

  constructor(
    private dialog: MatDialog,
    private storageService: StorageserviceService,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
    private auth: AuthService,
    private data: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private focusTrapFactory: FocusTrapFactory
  ) { }

  private attachPreviewOverlay(): void {
    if (this.previewOverlayRef?.hasAttached()) { return; }   // already open (viewDocument sets the flag more than once)
    this.previewOverlayRef = this.overlay.create({
      hasBackdrop: false,   // .preview-modal already supplies the full-viewport dimmed backdrop - avoids a duplicate one
      positionStrategy: this.overlay.position().global(),
      scrollStrategy: this.overlay.scrollStrategies.block()   // same scroll behaviour as MatDialog
    });
    this.previewOverlayRef.attach(new TemplatePortal(this.previewTpl, this.viewContainerRef));
  }

  private detachPreviewOverlay(): void {
    this.previewOverlayRef?.dispose();
    this.previewOverlayRef = null;
  }

  // Overlays outlive the component, so an open preview must be removed when the user navigates to another module.
  ngOnDestroy(): void {
    this.detachPreviewOverlay();
    this.disposeAddDocumentDialog?.();
  }

  // ---- Add / Edit Document dialog: custom CDK-overlay host (replaces MatDialog's container) ----
  // AddDocumentDialogComponent is unchanged: it still injects MatDialogRef / MAT_DIALOG_DATA, so those two tokens are
  // provided here with a minimal stand-in. `close(result)` and `afterClosed()` behave exactly as before.
  private disposeAddDocumentDialog: (() => void) | null = null;

  private openAddDocumentDialog(data: any): { afterClosed(): Observable<any> } {
    const overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'cdk-overlay-dark-backdrop',
      panelClass: 'document-dialog',          // keeps the existing `.document-dialog ...` rules in documents.component.css
      width: '600px',
      maxWidth: 'calc(100vw - 16px)',
      positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
      scrollStrategy: this.overlay.scrollStrategies.block()
    });
    // No backdrop-click / Escape handlers on purpose: the dialog was opened with disableClose: true.

    const closed$ = new Subject<any>();
    const previouslyFocused = document.activeElement as HTMLElement | null;
    let focusTrap: FocusTrap | null = null;
    let isClosed = false;

    const finish = (emit: boolean, result?: any): void => {
      if (isClosed) { return; }
      isClosed = true;
      this.disposeAddDocumentDialog = null;
      focusTrap?.destroy();
      overlayRef.dispose();
      previouslyFocused?.focus?.();
      if (emit) { closed$.next(result); }
      closed$.complete();
    };
    this.disposeAddDocumentDialog = () => finish(false);

    const dialogRefStandIn = { close: (result?: any) => finish(true, result) };
    const injector = Injector.create({
      parent: this.viewContainerRef.injector,
      providers: [
        { provide: MatDialogRef, useValue: dialogRefStandIn },
        { provide: MAT_DIALOG_DATA, useValue: data }
      ]
    });

    overlayRef.attach(new ComponentPortal(AddDocumentDialogComponent, this.viewContainerRef, injector));
    focusTrap = this.focusTrapFactory.create(overlayRef.overlayElement);
    focusTrap.focusInitialElementWhenReady();

    return { afterClosed: () => closed$.asObservable() };
  }

  ngOnInit(): void {
    const link = history.state?.dashboardDeepLink;
    if (link?.category) {
      this.dashboardLink = link;
      const { dashboardDeepLink, ...rest } = history.state;   // consume it so a page refresh does not repeat the action
      history.replaceState(rest, '');
    }
    this.route.queryParams.subscribe((params: Params) => {
    const countryFromParam = params['country'];
    
    if (countryFromParam) {
      // If country parameter exists, handle it specially
      console.log('Country from dashboard:', countryFromParam);
      
      // Load citizenships first
      this.auth.get_citizenship().subscribe((res: any) => {
        if (!res.error && res.data?.citizenships) {
          this.citizenships = res.data.citizenships;
          
          // Find matching citizenship (case-insensitive)
          const matchingCitizenship = this.citizenships.find(
            c => c.country.toLowerCase() === countryFromParam.toLowerCase()
          );
          
          if (matchingCitizenship) {
            // Set the selected citizenship from the query param
            this.selectedCitizenship = matchingCitizenship;
            this.index_country = matchingCitizenship.index;
            console.log('Auto-selected country:', this.selectedCitizenship.country);
          } else {
            // Fallback to primary if country not found
            console.warn('Country not found, using default');
            const primary = this.citizenships.find(c => c.index === 'citizen_primary');
            this.selectedCitizenship = primary || this.citizenships[0];
            this.index_country = this.selectedCitizenship?.index;
          }
          
          // Now load everything with the correct country
          this.loadCategories();
          this.loadDocuments();
          this.updateDocumentCounts();
          this.filterAndUpdateDocuments();
        }
      });
    } else {
      // Normal initialization (no query param)
      this.getCitizenships();
      this.loadCategories();
      this.loadDocuments();
      this.updateDocumentCounts();
      this.filterAndUpdateDocuments();
    }
  });
  
  }

  private loadDocuments(): void {
    if (this.tagSelected === 'identity') {
      this.load_identity_docs();
    } else {
      this.load_personal_docs();
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
   

  applyFilter(event: Event) {
  const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
  this.dataSource.filter = filterValue;

}
sortData(column: string) {
  const direction = this.sortDirection[column] === 'asc' ? 'desc' : 'asc';
  this.sortDirection[column] = direction;

    const sortedData = [...this.dataSource.data].sort((a, b) => {
        let valA: any = a[column];
        let valB: any = b[column];


        if (column === 'name') {
        valA = a.name || a.doctype || a.documentId || '';
        valB = b.name || b.doctype || b.documentId || '';
        }

    // Convert to lowercase string if it's a string (for case-insensitive sorting)
    if (typeof valA === 'string') valA = valA.toLowerCase();
    if (typeof valB === 'string') valB = valB.toLowerCase();

    if (valA < valB) return direction === 'asc' ? -1 : 1;
    if (valA > valB) return direction === 'asc' ? 1 : -1;
    return 0;
  });

  this.dataSource.data = sortedData;
}

get paginatedGridData() {
  if (!this.dataSource || !this.dataSource.data) {
    return [];
  }
  
  const startIndex = this.paginator ? this.paginator.pageIndex * this.paginator.pageSize : 0;
  const endIndex = this.paginator ? startIndex + this.paginator.pageSize : 10;
  
  return this.dataSource.data.slice(startIndex, endIndex);
}

getIconImagePath(iconKey: string): string {
  const mapping = this.iconMappings.find(m => m.key === iconKey);
  if (mapping) {
    return mapping.imagePath;
  }
  
  // Better fallback and debugging
  console.warn(`No image mapping found for icon key: "${iconKey}". Available keys:`, 
    this.iconMappings.map(m => m.key));
  return 'assets/file_folder.png'; // default fallback
}

searchDocumentsx(searchText: string) {
  if (!searchText) {
    this.dataSource.data = this.allDocuments;
    return;
  }

  const lowerSearch = searchText.toLowerCase();

  const filtered = this.allDocuments.filter(doc => {
    if (this.tagSelected === 'identity') {
      return (
        (doc.doctype && doc.doctype.toLowerCase().includes(lowerSearch)) ||
        (doc.name && doc.name.toLowerCase().includes(lowerSearch))
      );
    } else {
      return doc.name && doc.name.toLowerCase().includes(lowerSearch);
    }
  });

  this.dataSource.data = filtered;
}
// searchDocuments(searchText: string) {
//   if (!searchText) {
//     this.dataSource.data = this.allDocuments;
//     return;
//   }

//   const lowerSearch = searchText.toLowerCase();

//   const filtered = this.allDocuments.filter(doc => {
//     // normalize dates
//     const uploadedOn = doc.uploadDate ? this.formatDate(doc.uploadDate).toLowerCase() : '';
//     const expiringOn = doc.expirationDate ? this.formatDate(doc.expirationDate).toLowerCase() : '';

//     // normalize tags (array -> string)
//     const tags = doc.tags ? doc.tags.join(' ').toLowerCase() : '';

//     if (this.tagSelected === 'identity') {
//       return (
//         (doc.doctype && doc.doctype.toLowerCase().includes(lowerSearch)) ||
//         (doc.name && doc.name.toLowerCase().includes(lowerSearch)) ||
//         (doc.docid && doc.docid.toLowerCase().includes(lowerSearch)) ||
//         uploadedOn.includes(lowerSearch) ||
//         expiringOn.includes(lowerSearch) ||
//         tags.includes(lowerSearch)
//       );
//     } else {
//       return (
//         (doc.name && doc.name.toLowerCase().includes(lowerSearch)) ||
//         (doc.description && doc.description.toLowerCase().includes(lowerSearch)) ||
//         uploadedOn.includes(lowerSearch) ||
//         expiringOn.includes(lowerSearch) ||
//         tags.includes(lowerSearch)
//       );
//     }
//   });

//   this.dataSource.data = filtered;
// }

  searchDocuments(searchText: string) {
    if (!searchText) {
      this.dataSource.data = this.allDocuments;
      return;
    }

    const lowerSearch = searchText.toLowerCase();

    const filtered = this.allDocuments.filter(doc => {
      // normalize dates
      const uploadedOn = doc.uploadDate ? this.formatDate(doc.uploadDate).toLowerCase() : '';
      const expiringOn = doc.expirationDate ? this.formatDate(doc.expirationDate).toLowerCase() : '';

      // normalize tags (array -> string)
      const tags = doc.user_tags ? doc.user_tags.join(' ').toLowerCase() : '';

      // normalize docid (number or string)
      const docid = doc.docid ? String(doc.docid).toLowerCase() : '';

      if (this.tagSelected === 'identity') {
        return (
          (doc.doctype && doc.doctype.toLowerCase().includes(lowerSearch)) ||
          (doc.name && doc.name.toLowerCase().includes(lowerSearch)) ||
          docid.includes(lowerSearch) ||   // ✅ fixed
          uploadedOn.includes(lowerSearch) ||
          expiringOn.includes(lowerSearch) ||
          tags.includes(lowerSearch)
        );
      } else {
        return (
          (doc.name && doc.name.toLowerCase().includes(lowerSearch)) ||
          (doc.description && doc.description.toLowerCase().includes(lowerSearch)) ||
          uploadedOn.includes(lowerSearch) ||
          expiringOn.includes(lowerSearch) ||
          tags.includes(lowerSearch)
        );
      }
    });

    this.dataSource.data = filtered;
  }

  load_identity_docs() {
    this.auth.get_crediential_docs(this.index_country).subscribe({
      next: (res: any) => {
        console.log('Credential docs response:', res);

        if (!res.error && res.data?.documents?.length) {
          let identityDocsCount = 0;
          identityDocsCount = res?.data?.documents.length;
          localStorage.setItem('identityDocsCount', identityDocsCount.toString());
          this.allDocuments = res.data.documents.map((doc: any) => ({
            ...doc,

            // Parse created date (if needed)
            uploadDate: doc.created ? new Date(doc.created) : undefined,

            // Parse expiration date (if present)
            expirationDate: doc.expiration_date ? new Date(doc.expiration_date) : undefined,

            // Ensure category is an array
            category: Array.isArray(doc.category) ? doc.category : [doc.category],
            mimeType: doc.content_type || 'application/pdf', // Default to PDF if not specified

            // Sanitize preview URL for safe use in templates
            previewUrl: doc.url ? this.sanitizer.bypassSecurityTrustResourceUrl(doc.url) : undefined
          })).reverse();
          console.log('Processed documents:', this.allDocuments);

          const identityCategory = this.documentCategories.find(cat => cat.title === 'Identity');
          if (identityCategory) {
            identityCategory.count = identityDocsCount;
          }

          // Apply to MatTableDataSource
          this.dataSource = new MatTableDataSource(this.allDocuments);
          this.dataSource.paginator = this.paginator;

          this.saveDocuments(); // optional: store locally
          this.filterAndUpdateDocuments(); // refresh UI or filtered list
        } else {
          this.allDocuments = [];
          //this.toastr.warning('No documents found.');
        }
      },
      error: (err) => {
        console.error('Error loading credential documents:', err);
        this.toastr.error('Failed to load documents. Please try again later.');
        this.allDocuments = [];
      }
    });

  }


  load_personal_docs() {
    console.log('Loading personal documents for tag:', this.tagSelected, 'and country index:', this.index_country);

    this.auth.get_personal_docs_tag(this.tagSelected, this.index_country).subscribe({
      next: (res: any) => {
        console.log('docres',res)
        if (!res.error && res.data?.documents?.length) {
          this.allDocuments = res.data.documents.map((doc: any) => ({
            ...doc,

            // Parse created date (if needed)
            uploadDate: doc.created ? new Date(doc.created) : undefined,

            // Parse expiration date (if present)
            expirationDate: doc.expiration_date ? new Date(doc.expiration_date) : undefined,

            // Ensure category is an array
            category: Array.isArray(doc.category) ? doc.category : [doc.category],
            mimeType: doc.content_type || 'application/pdf', // Default to PDF if not specified
            // added_encryption: doc.is_encrypted || false,
            // Sanitize preview URL for safe use in templates
            previewUrl: doc.url ? this.sanitizer.bypassSecurityTrustResourceUrl(doc.url) : undefined
          })).reverse();

          // Apply to MatTableDataSource
          this.dataSource = new MatTableDataSource(this.allDocuments);
          this.dataSource.paginator = this.paginator;

          console.log('Processed documents:', this.allDocuments);

          this.saveDocuments(); // optional: store locally
          this.filterAndUpdateDocuments(); // refresh UI or filtered list
          this.runDashboardAction();
        } else {
          this.allDocuments = [];
          // this.toastr.warning('No documents found.');
          this.runDashboardAction();
        }
      },
      error: (err) => {
        console.error('Error loading credential documents:', err);
        this.toastr.error('Failed to load documents. Please try again later.');
        this.allDocuments = [];
      }
    });

  }
  getCitizenships() {
    this.auth.get_citizenship().subscribe((res: any) => {
      if (!res.error && res.data?.citizenships) {
        this.citizenships = res.data.citizenships;

      // reassign selectedCitizenship if it exists in new list
      if (this.selectedCitizenship) {
        const match = this.citizenships.find(
          c => c.index === this.selectedCitizenship.index
        );
        if (match) {
          this.selectedCitizenship = match;
          return; // keep selection, don’t overwrite below
        }
      }
        // Set default to primary
        const primary = this.citizenships.find(c => c.index === 'citizen_primary');
        this.selectedCitizenship = primary || this.citizenships[0];  // fallback to first if no primary
      }
    });
  }


  getCountryImagePath(country: string): string {
    if (!country) return 'assets/images/flag/default.png';
    const filename = country.toLowerCase().replace(/ /g, '-');
    return `assets/images/flag/${filename}.png`;
  }

  selectCitizenship(citizenship: any) {
    this.selectedCitizenship = citizenship;
    this.index_country = citizenship.index;
    this.loadCategories();
    this.loadDocuments();
    console.log('Selected Citizenship:', this.selectedCitizenship);
  }

  //  private loadCategories(): void {
  //       this.auth.get_tag_counts(this.index_country).subscribe({
  //         next: (response: any) => {
  //           if (!response.error && response.data?.counts) {
  //             const newCategories = response.data.counts.map((item: any) => ({
  //               id: item.tagName.toLowerCase(),
  //               title: item.tagName,
  //               count: item.count,
  //               icon: this.getIconForTag(item.tagName),
  //               isActive: false,
  //               documentTypes: [] // Optional: fetch or assign if needed
  //             }));

  //             // Append to existing documentCategories (without duplicates)
  //             newCategories.forEach((newCat:any) => {
  //               const exists = this.documentCategories.some(
  //                 existingCat => existingCat.id === newCat.id
  //               );
  //               if (!exists) {
  //                 this.documentCategories.push(newCat);
  //               }
  //             });
  //           }
  //         },
  //         error: (error:any) => {
  //           console.error('Failed to load categories:', error);
  //         }
  //       });
  //     }
  private loadCategories(): void {
  const identityDocsCount = parseInt(localStorage.getItem('identityDocsCount') || '0', 10);
  // Step 1: Add static identity category with image-based icon
  this.documentCategories = [{
    id: 'identity',
    title: 'Identity',
    count: identityDocsCount,
    icon: 'card_membership', // Keep the key, but we'll convert to image in template
    isActive: this.tagSelected === 'identity',
    documentTypes: [
      { value: 'aadhar', title: 'Aadhar' },
      { value: 'passport', title: 'Passport' },
      { value: 'driver_license', title: 'Driver License' },
      { value: 'voterid', title: 'Voter Id' }
    ]
  }];

  // Step 2: Fetch dynamic categories
  this.auth.get_tags(this.index_country).subscribe({
    next: (tagRes: any) => {
      const apiCategories = tagRes?.data?.categories;
      if (!apiCategories || tagRes.error) {
        console.warn('No tag categories found');
        return;
      }

      // Step 3: Build and merge dynamic categories
      apiCategories.forEach((cat: any) => {
        const titleLower = cat.tagname?.toLowerCase();
        // if (titleLower === 'identity') return; // avoid overriding static identity

        const isActive = this.tagSelected === cat.id;
        const iconKey = this.getCategoryIconKey(cat.tagname, cat.symbol);
        const newCategory = {
          id: cat.id,
          title: cat.tagname,
          count: cat.count || 0,
          icon: iconKey, // This will be converted to image in template
          isActive,
          documentTypes: []
        };

        // Add to list only if not already present
        const existingIndex = this.documentCategories.findIndex(
          existing => existing.title === newCategory.title
        );

        if (existingIndex > -1) {
          this.documentCategories[existingIndex].count = newCategory.count;
          this.documentCategories[existingIndex].id = newCategory.id;
          this.documentCategories[existingIndex].icon = newCategory.icon;
        } else {
          this.documentCategories.push(newCategory);
        }
      });

      console.log('Document Categories:', this.documentCategories);
      this.applyDashboardLink();
    },
    error: err => {
      console.error('Failed to load tag categories:', err);
    }
  });
}

/** Health Dashboard deep link: select the requested category once the categories (with their ids) are loaded. */
private applyDashboardLink(): void {
  const link = this.dashboardLink;
  if (!link) { return; }
  this.dashboardLink = null;
  const target = this.documentCategories.find(c => (c.title || '').toLowerCase() === link.category);
  if (!target) { return; }
  this.dashboardAction = { docId: link.docId, add: link.add };
  this.setActiveDocument(target);   // existing category selection: loads that category's documents
}

/** Runs after the selected category's documents have loaded: open one document's preview or the Add Documents dialog. */
private runDashboardAction(): void {
  const action = this.dashboardAction;
  if (!action) { return; }
  this.dashboardAction = null;
  if (action.docId) {
    const doc = this.allDocuments.find(d => String(d.id) === String(action.docId));
    if (doc) {
      this.viewDocument(doc);   // existing preview
    } else {
      this.toastr.warning('Preview not available.');
    }
  } else if (action.add) {
    this.onAddDocument();       // existing Add Documents dialog (defaultCategory = selected category)
  }
}

private getCategoryIconKey(categoryName: string, apiSymbol?: string): string {
  const normalizedName = categoryName?.toLowerCase() || '';
  
  // First, try to use the API symbol if it exists and is mapped
  if (apiSymbol && this.iconMappings.find(m => m.key === apiSymbol)) {
    return apiSymbol;
  }
  
  // Fallback to category name mapping
  switch (normalizedName) {
    case 'identity': return 'insert_drive_file';//card_membership';
    case 'personal': return 'personal-card';
    case 'health': return 'local_hospital';
    case 'legal': return 'gavel';
    case 'finance': return 'account_balance';
    case 'legalfinance': return 'legal-card';
    case 'others': return 'stack';
    default:
      // If we have an API symbol but it's not in our mappings, use it anyway
      // The getIconImagePath method will handle the fallback
      return apiSymbol || 'insert_drive_file';
  }
}

  get_category_ids() {
    this.auth.get_tags(this.index_country).subscribe({
      next: (res: any) => {
        console.log('Tag list response:', res);
      },
    })
  }

  private getIconForTag(tagName: string): string {
    switch (tagName.toLowerCase()) {
      case 'identity': return 'badge';
      case 'health': return 'local_hospital';
      case 'legal': return 'gavel';
      case 'personal': return 'person';
      case 'finance': return 'account_balance';
      case 'others': return 'insert_drive_file';
      default: return 'insert_drive_file';
    }
  }




  private saveDocuments(): void {
    try {
      const documentsToSave = this.allDocuments.map((doc) => {
        const { fileData, previewUrl, ...docToSave } = doc;
        return docToSave;
      });

      const documentsString = JSON.stringify(documentsToSave);

      // Check if the size is within limits
      if (this.isStorageAvailable(documentsString)) {
        this.storageService.setItem('documents', documentsString);
      } else {
        console.error('Failed to save documents: Storage quota exceeded');
      }
    } catch (error) {
      console.error('Failed to save documents:', error);
    }
  }

  // Helper function to check localStorage quota
  private isStorageAvailable(data: string): boolean {
    try {
      const testKey = 'test';
      localStorage.setItem(testKey, data);
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }


  toggleView(): void {
    this.viewMode = this.viewMode === 'list' ? 'grid' : 'list';
  }

  sortByDate(criteria: string): void {
    if (criteria === 'new to old') 
      this.allDocuments.sort((a: any, b: any) => new Date(b.created).getTime() - new Date(a.created).getTime());
    else
      this.allDocuments.sort((a: any, b: any) => new Date(a.created).getTime() - new Date(b.created).getTime());
  }

  onSort(criteria: string, option: string = 'asc') {
    this.sortBy = criteria;
    const sorted = [...this.allDocuments];

    sorted.sort((a, b) => {
      if (criteria === 'name') {
        if (this.tagSelected === 'identity') {
          return option === 'asc' 
                  ? (a.doctype || '').localeCompare(b.doctype || '') 
                  : (b.doctype || '').localeCompare(a.doctype || '');
        } else {
          return option === 'asc' 
                  ? (a.name || '').localeCompare(b.name || '') 
                  : (b.name || '').localeCompare(a.name || '');
        }
      } else if (criteria === 'date') {
        return option === 'asc' 
                  ? new Date(a.uploadDate).getTime() - new Date(b.uploadDate).getTime()
                  : new Date(b.uploadDate).getTime() - new Date(a.uploadDate).getTime();
      }
      return 0;
    });

    this.allDocuments = sorted;
    this.dataSource.data = sorted; // For mat-table list view
  }


  /** Max characters shown in a tag chip; longer tags end with '...' and show in full in a tooltip. Display only - stored tags are never changed. */
  readonly maxTagChars = 15;

  truncateTag(tag: any): string {
    const text = tag == null ? '' : String(tag);
    return text.length > this.maxTagChars ? text.slice(0, this.maxTagChars).trimEnd() + '...' : text;
  }

  /** Tooltip text: the full tag, only when it was truncated (empty string disables the tooltip). */
  tagTooltip(tag: any): string {
    const text = tag == null ? '' : String(tag);
    return text.length > this.maxTagChars ? text : '';
  }

  formatDate(date: Date): string {
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  onAddDocument(category?: string): void {
    const dialogRef = this.openAddDocumentDialog({
      mode: 'add',
      defaultCategory: this.tagSelected,
      categories: this.documentCategories,
      index_country: this.index_country,
      country: this.selectedCitizenship?.country || '',
      existingDocuments: this.allDocuments || []
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log('New document data:', result);
      // Reload documents first, then categories to get updated counts
      this.loadDocuments();
      // Wait for documents to load before reloading categories with fresh counts
      setTimeout(() => {
        this.loadCategories();
      }, 800);
    });
  }

  refreshDocuments() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  async handleDocumentUpload(result: any): Promise<void> {
    const file = result.files[0];

    // Create new document object
    const newDocument: Document = {
      id: (this.allDocuments.length + 1).toString(),
      name: result.name,
      category: result.categories,
      doctype: result.doctype,
      documentId: result.documentId,
      uploadDate: new Date(),
      description: result.description,
      fileSize: this.calculateFileSize(file),
      tags: result.tags,
      expirationDate: result.expirationDate,
      fileData: file,
      mimeType: file.type,
      uploadProgress: 0
      // previewUrl: file.type.startsWith('image/') ? this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file)) : undefined
    };

    // Simulate file upload progress
    const uploadInterval = setInterval(() => {
      if (newDocument.uploadProgress! < 100) {
        newDocument.uploadProgress! += 10;
        this.updateDocument(newDocument);
      } else {
        clearInterval(uploadInterval);
        this.finalizeDocumentUpload(newDocument);
      }
    }, 300);

    this.allDocuments.push(newDocument);
    this.filterAndUpdateDocuments();
    this.updateDocumentCounts();
  }

  private async fileToDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  private updateDocument(document: Document): void {
    const index = this.allDocuments.findIndex(doc => doc.id === document.id);
    if (index !== -1) {
      this.allDocuments[index] = document;
      this.filterAndUpdateDocuments();
    }
  }

  private finalizeDocumentUpload(document: Document): void {
    document.uploadProgress = 100;
    this.updateDocument(document);
    this.saveDocuments();
  }


  private calculateFileSize(file: File): string {
    const sizeInBytes = file.size;
    const sizeInMB = sizeInBytes / (1024 * 1024);
    return sizeInMB.toFixed(2) + ' MB';
  }

  private updateDocumentCounts(): void {
    this.documentCategories.forEach((card) => {
      card.count = this.allDocuments.filter(
        (doc) => doc.category.some(cat => cat.toLowerCase() === card.id)
      ).length;
    });
  }

  setActiveDocument(selected: any): void {
    console.log('Selected document category:', selected);
    if(selected.title.toLowerCase() === 'identity') {
      this.displayedColumns = ['name', 'description', 'uploadedOn', 'expiringOn', 'tags', 'actions'];
      this.tagSelected = 'identity';
    }
    else {
      this.displayedColumns = ['name', 'description', 'uploadedOn', 'expiringOn', 'tags','actions'];
      this.tagSelected = selected.id;
    }

    this.documentCategories = this.documentCategories.map((card) => ({
      ...card,
      isActive: card.id === selected?.id,
    }));
      // Reload categories to refresh counts
    this.loadCategories();
    
    // Reload documents based on the selected category
    this.loadDocuments();
    
    // Wait a bit for documents to load, then update counts again
    setTimeout(() => {
      this.filterAndUpdateDocuments();
    }, 500);
  }

  public filterAndUpdateDocuments(): void {
    let filteredDocs = this.filterDocuments();
    this.totalDocuments = filteredDocs.length;
    this.documents = this.getPaginatedDocuments(filteredDocs);
  }

  private filterDocuments(): Document[] {
    let filteredDocs = [...this.allDocuments];

    const activeCard = this.documentCategories.find((card) => card.isActive);
    if (activeCard) {
      filteredDocs = filteredDocs.filter(
        (doc) => doc.category.some(cat => cat.toLowerCase() === activeCard.id)
      );
    }

    if (this.searchQuery.trim()) {
      const query = this.searchQuery.toLowerCase().trim();
      filteredDocs = filteredDocs.filter(
        (doc) =>
          doc.name.toLowerCase().includes(query) ||
          doc.description.toLowerCase().includes(query) ||
          doc.tags.some((tag) => tag.toLowerCase().includes(query))
      );
    }

    filteredDocs.sort((a, b) => {
      if (this.sortBy === 'name') {
        return a.name.localeCompare(b.name);
      } else if (this.sortBy === 'date') {
        return b.uploadDate.getTime() - a.uploadDate.getTime();
      }
      return 0;
    });

    return filteredDocs;
  }

  onDocumentAction(action: string, document: Document): void {
    switch (action) {
      case 'view':
        this.viewDocument(document);
        break;
      case 'edit':
        this.editDocument(document);
        break;
      case 'share':
        this.shareDocument(document);
        break;
      case 'download':
        this.downloadDocument(document);
        break;
      case 'delete':
        this.deleteDocument(document);
        break;
    }
  }

    // Preview document
  openPreview(document: Document): void {
    this.previewDocument = document;
    this.isPreviewOpen = true;
    // render modal & spinner first
    // setTimeout(() => {
    //   this.viewDocument(document);
    // }, 0);
  }

  // viewDocument(document: any): void {
  //   console.log('Viewing document:', document);
  //   if (document.previewUrl) {
  //     // document.previewUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(document.fileData));
  //     this.openPreview(document);
  //   }
  //   else {
  //     console.error('No file data available for preview');
  //   }
  // }

  viewDocument(document: any): void {
    //console.log('Viewing document:', document);

    // Always open the modal and spinner immediately
    this.previewDocument = null; // reset
    this.isPreviewOpen = true;
    this.isPreviewLoading = true;

    if (this.allowedFileTypes.includes(document.content_type)) {
      const url = this.docapi;

      // Let Angular render modal & spinner first
      setTimeout(() => {
        this.auth.sendPostDecryptRequest(url, { url: document.url }).subscribe({
          next: (res: any) => {
            const blob = new Blob([res], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            document.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
            document.mimeType = 'application/pdf';

            this.previewDocument = document;
            this.isPreviewLoading = false;
          },
          error: (err) => {
            console.error('Error converting document:', err);
            this.toastr.error('Failed to convert file.');
            this.isPreviewLoading = false;
          }
        });
      }, 0); // small delay to allow spinner render

    } else if (document.previewUrl) {
      this.previewDocument = document;
      this.isPreviewOpen = true;
      this.isPreviewLoading = false;
    } else {
      this.toastr.warning('Preview not available.');
      this.isPreviewOpen = false;
      this.isPreviewLoading = false;
    }
  }

  editDocument(document: Document): void {
    const dialogRef = this.openAddDocumentDialog({
      mode: 'edit',
      document: { ...document },
      defaultCategory: this.tagSelected,
      categories: this.documentCategories,
      index_country: this.index_country,
      country:this.selectedCitizenship?.country || '',
      existingDocuments: (this.allDocuments || [])
        .filter((d: any) => d?.id !== document.id)
    });

    dialogRef.afterClosed().subscribe((result) => {
    if (result) {   // ✅ only process when valid result comes back
      const index = this.allDocuments.findIndex(doc => doc.id === result.id);
      if (index !== -1) {
        this.allDocuments[index] = result;
        this.loadDocuments();
      } else {
        // If not found in current list, reload everything
        this.loadDocuments();
      }
    }
    });
  }

  shareDocument(document: Document): void {
    const dialogRef = this.dialog.open(SharedocumentdialogComponent, {
      width: '600px',
      panelClass: 'share-dialog',
      data: { document, "category": this.tagSelected }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Show success snackbar or notification
        console.log('Document shared with:', result);
        // Here you would implement your actual sharing logic
        // This could include sending APIs requests to your backend
      }
    });
  }

  downloadDocument(document: any): void {
    let docname = this.tagSelected === 'identity' ? document.doctype : document.name;
    docname = this.getReadableDocType(docname, document.country || '');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Download Document', message: `Are you sure you want to download "${docname}" document?`, sub:'This will save a copy of the document to your device.', show: true }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.tagSelected == 'identity') 
          this.download_credential(document.doctype);

        else 
          this.download_personal(document.id);

        setTimeout(() => {
          this.toastr.success('you have successfully download the document.', 'Success'); 
        }, 2000);
      }
    })
  }

  download_credential(type: any) {

    this.auth.download_credentials(this.index_country, type).subscribe((res: any) => {
      if (res.error == false) {
        window.open(res.data.url, '_blank');
      }

    })
  }

  download_personal(id:any){
    this.auth.download_personal(id).subscribe((res:any)=>{
      if(res.error==false){
        window.open(res.data.url,'_blank');
      }

    })
  }

  getReadableDocType(doctype: string, country: string): string {
    const pipe = new DoctypePipe();  // create pipe instance
    return pipe.transformDoctype(doctype,country);  // use the pipe's transform logic
  }


  deleteDocument(document: Document): void {
    let docname = this.tagSelected === 'identity' ? document.doctype : document.name;
    docname = this.getReadableDocType(docname, document.country || '');
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Delete Document', message: `Are you sure want to delete "${docname}" document?`, sub:'You will not be able to recover it once it is deleted.' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (this.tagSelected === 'identity') {
          this.auth.delete_credentiall_docs(this.index_country, document.doctype).subscribe((res: any) => {
            if (res && res.msg) {
              this.toastr.success('Document deleted successfully', 'Success');
              this.allDocuments = this.allDocuments.filter((doc) => doc.id !== document.id);
              this.loadCategories();
              this.loadDocuments();
            } else {
              this.toastr.error('Failed to delete document', 'Error');
            }
          });
        } else {
          this.auth.delete_personal_doc(document.id).subscribe((res: any) => {
            if (res && res.msg) {
              this.toastr.success('Document deleted successfully', 'Success');
              this.allDocuments = this.allDocuments.filter((doc) => doc.id !== document.id);
              this.loadCategories();
              this.loadDocuments();
            } else {
              this.toastr.error('Failed to delete document', 'Error');
            }
          });
        }



      }
    });
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src = 'assets/images/pdf.svg';
  }

  onAddCategory(): void {
  const dialogRef = this.dialog.open(AddCategoryDialogComponent, {
    width: '500px',
    data: { existingCategories: this.documentCategories }
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log('Dialog returned:', result); // Debug log

    if (result) {
      // ✅ Use result.categoryName instead of result.name
      const newCategory: DocumentCategory = {
        id: result.categoryName.toLowerCase(),
        title: result.categoryName,
        count: 0,
        icon: result.icon,
        isActive: false
      };

      // ✅ Use result.categoryName in payload
      let payload = {
        "category": result.categoryName,
        "symbol": result.icon
      };

      console.log('Creating category with payload:', payload); // Debug log

      this.auth.add_tags(this.index_country, payload).subscribe({
        next: (res: any) => {
          console.log('API Response:', res); // Debug log
          if (res.error === false) {
            console.log('New category created:', newCategory);
            this.documentCategories.push(newCategory);
            this.updateDocumentCounts();
            this.loadCategories();
            this.toastr.success(res.msg);
          } else if (res.error === true) {
            this.toastr.error(res.msg);
          }
        },
        error: (err) => {
          console.error('API Error:', err);
          if (err.error && err.error.msg) {
            this.toastr.error(err.error.msg); 
          } else {
            this.toastr.error('Something went wrong. Please try again.');
          }
        }
      });
    } else {
      console.log('Dialog was cancelled or returned no result');
    }
  });
}


  onEditCategory(category: any) {
  console.log('category', category)
  const dialogRef = this.dialog.open(AddCategoryDialogComponent, {
    width: '500px',
    data: {
      existingCategories: this.documentCategories,
      category: category   // 👈 pass category to edit
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    console.log('Edit dialog result:', result); // Debug log

    if (result) {
      // ✅ Use result.categoryName instead of result.name
      let newCategory: DocumentCategory = {
        id: result.categoryName.toLowerCase(),
        title: result.categoryName,
        count: category.count, // Keep existing count
        icon: result.icon,
        isActive: category.isActive // Keep existing active state
      };

      // Update the category in the array
      category.title = result.categoryName;
      category.icon = result.icon;
      
      // ✅ Use result.categoryName in payload
      let payload = {
        "category": result.categoryName,
        "symbol": result.icon
      };

      console.log('Updating category with payload:', payload);
      console.log('category.id', category.id);

      this.auth.update_tags(category.id, payload).subscribe({
        next: (res: any) => {
          console.log('Update API Response:', res); // Debug log
          if (res.error === false) {
            console.log('Category updated successfully:', newCategory);
            this.toastr.success(res.msg);
            this.loadCategories();
            this.loadDocuments();
          } else if (res.error === true) {
            this.toastr.error(res.msg);
          }
        },
        error: (err) => {
          console.error('Update API Error:', err);
          if (err.error && err.error.msg) {
            this.toastr.error(err.error.msg);
          } else {
            this.toastr.error('Something went wrong. Please try again.');
          }
        }
      });
    } else {
      console.log('Edit dialog was cancelled or returned no result');
    }
  });
}

  onDeleteCategory(category: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { title: 'Delete Folder', message: 'Are you sure you want to delete this folder?', sub: 'You will not be able to recover it once it is deleted.' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.auth.delete_tags(this.index_country, category.id).subscribe({
          next: (res: any) => {
            if (!res.error) {
              this.toastr.success(res.msg);
              this.loadCategories();
            }
          },
          error: (err) => {
            this.toastr.error(err.error.msg || "Failed to delete tag. Please try again.");
          }
        });
        
      }
    });
  }

  reGetCategory() {
    const currentUrl = this.router.url; this.router.navigateByUrl('/', {
      skipLocationChange: true
    }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  // Add this method to save categories
  private saveCategories(): void {
    try {
      this.storageService.setItem('documentCategories', JSON.stringify(this.documentCategories));
    } catch (error) {
      console.error('Failed to save folder:', error);
    }
  }

  // Pagination handling
  onPageChange(event: any): void {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filterAndUpdateDocuments();
  }

  private getPaginatedDocuments(documents:any): any {
    const startIndex = this.currentPage * this.pageSize;
    return documents.slice(startIndex, startIndex + this.pageSize);
  }

  closePreview(): void {
    if (this.previewDocument?.previewUrl) {
      URL.revokeObjectURL(this.previewDocument.previewUrl.toString());
    }
    this.previewDocument = null;
    this.isPreviewOpen = false;
  }

  scrollLeft() {
    this.cardContainer.nativeElement.scrollLeft -= 200;
  }

  scrollRight() {
    this.cardContainer.nativeElement.scrollLeft += 200;
  }

}